function toggleAccordion(cta, target) {
	if (!target.hasClass('transition')) {
		target.addClass('transition');
		cta.toggleClass('active');
		target.slideToggle(speed, ease, () => {
			target.removeClass('transition');
		});
	}
}

$('.accordion-trigger').click(function () {
	const target = $(this);
	const active = $('.accordion-trigger.active').not(target);
	if (active.length) {
		toggleAccordion(active, active.next());
		setTimeout(() => {
			toggleAccordion(target, target.next());
		}, speed);
	} else {
		toggleAccordion(target, target.next());
	}
});